export const MENTION_REGEX = /@uid:(\d+)/g;
